const $ = require('jquery');
global.$ = $;
global.jQuery = $;

$(document).ready(function () {
  $('.tab-content').each(function () {
    $(this)
      .find('div[role="tabpanel"]')
      .each(function (index) {
        if (index !== 0) {
          $(this).hide();
        }
      });
  });

  $('body').on('click', '.nav-tabs a', function (e) {
    // Hide all tabPanels
    const tabPanels = $(this).closest('.nav-tabs').next('.tab-content').find('div[role="tabpanel"]').hide();

    // Show the selected tabPanel
    $(this.getAttribute('href')).show();
  });
});
